import { render, staticRenderFns } from "./StatsPlugin.vue?vue&type=template&id=6e35af98&scoped=true"
import script from "./StatsPlugin.vue?vue&type=script&lang=ts"
export * from "./StatsPlugin.vue?vue&type=script&lang=ts"
import style0 from "./StatsPlugin.vue?vue&type=style&index=0&id=6e35af98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35af98",
  null
  
)

export default component.exports